import Root from './containers/Root'
import {BrowserRouter as Router} from 'react-router-dom'
import React from "react";
import {render, hydrate} from "react-dom";
import {history} from './helpers/history';
import ReactDOM from 'react-dom';
import configureStore from "./store/configureStore";
import {getStoreDef} from './store/createStore';

function b64DecodeUnicode(str) {
    if (Object.keys(str).length === 0) {
        return '{}';
    }
    return decodeURIComponent(Array.prototype.map.call(atob(str), function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))
}


global.SSR_DATA = JSON.parse(b64DecodeUnicode(global.__DATA));


let appID = document.getElementById('app');
if (appID !== null) {
    ReactDOM.hydrate(
        <Router basename={process.env.BASE_URL} history={history}  >
            <Root store={configureStore(SSR_DATA.store ? SSR_DATA.store : getStoreDef())} />
        </Router>,
        appID
    )
}